import axios from "axios";
import { MeasurementDatasetsFetchFailedError, NotImplementedError } from "../../errors";
import { measurementDatasetFromService } from "../../models/dataManagementPlatform/measurementDataset";
import { parseIdFilter } from "../../handlers/filter";
import { PromiseHandler } from "../../handlers";
import { parseNewNewYorkApiResponse } from "../../utils";
/** Read-only listing of the 1P external measurement audiences an org can retarget on. */
class MeasurementDatasetsHandler extends PromiseHandler {
    constructor(sdk) {
        super(sdk, "measurementDatasets", { ttl: 300000 });
    }
    /** Datasets are identified by their vendor report id; there is no `id` field. */
    getIdentifierKey() {
        return "reportId";
    }
    /** @param filters requires an "id" filter carrying the audience-link owner's organization id */
    async findItems(filters) {
        const organizationIds = parseIdFilter(filters);
        if (organizationIds.size !== 1) {
            throw new MeasurementDatasetsFetchFailedError(new Error("a single organization id is required to list measurement datasets"));
        }
        const organizationId = organizationIds.values().next().value;
        const url = `${this.sdk.urls.baseAPIUrl}/organization/${organizationId}/measurementDatasets`;
        try {
            return await this.cache.promise(url, () => axios.get(url).then((response) => {
                const { data } = parseNewNewYorkApiResponse(response);
                // The envelope parser validates the wrapper and status but not the payload.
                // A non-array must not cache as "this org has none", which would silently
                // hide the retargeting option; an empty result arrives as [].
                if (!Array.isArray(data)) {
                    throw new Error("unexpected measurement datasets payload");
                }
                return data.map(measurementDatasetFromService);
            }));
        }
        catch (error) {
            throw new MeasurementDatasetsFetchFailedError(error);
        }
    }
    saveItem() {
        throw new NotImplementedError("measurement datasets are read-only");
    }
    deleteItem() {
        throw new NotImplementedError("measurement datasets are read-only");
    }
}
export default MeasurementDatasetsHandler;
//# sourceMappingURL=index.js.map